import { Injectable, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { ApiService } from "./api.service";
import { BrowserStorageService } from "./browser-storage.service";
import { appConstants } from "./constants/app.constants";
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
export type Area = {
  state: any;
  city: any;
};
export type IArea = {
  country: any;
  city: any;
};
@Injectable({
    providedIn: "root"
})
export class CommonService {
  private selectedAreaObject: Area = { state: '', city: '' };
  private selectedCountryObject: IArea = { country: '', city: '' };
  private pinObject:any;
    constructor(
        private toastr: ToastrService,
        private router: Router,
        private browserStore: BrowserStorageService,
        private _apiService: ApiService,
        @Inject(DOCUMENT) private document: any,
        public meta: Meta,
        public pageTitle: Title,
    ) {
    }

    public copyContent(content: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = content;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.toastr.success('Copied!');
    }
    isAuthenticated() {
        return localStorage.getItem('currentUser') ? true : false;
    }
    setLocation(areaType: 'domestic' | 'international', areaObj: any){
      if(areaType === 'domestic'){
        this.selectedAreaObject = areaObj;
      } else {
        this.selectedCountryObject = areaObj;
      }
    }
    getLocation(areaType: 'domestic' | 'international'): Area | IArea | any{
      return (areaType === 'domestic') ? this.selectedAreaObject : this.selectedCountryObject;
    }
    clearLocation(){
      this.selectedAreaObject = { state: '', city: '' };
      this.selectedCountryObject = { country: '', city: '' };
    }
    setPin(pinObject:any){
      this.pinObject = pinObject;
    }
    getPin(){
      return this.pinObject;
    }
    clearPin(){
      this.pinObject = false;
    }
    getTotalCartAmount(cartItemsArr: any) {
        let amount = {
            total: 0,
            discount: 0,
            payable: 0
        }
        cartItemsArr.forEach((each: any) => {
            if (each && each.attributes.quantity) {
                amount.total = amount.total + (each.attributes?.details?.denomination * each.attributes?.quantity);
                amount.discount = amount.discount + (
                    (each.attributes?.details?.denomination * each.attributes?.quantity) -
                    (each.attributes?.details?.discounted_value * each.attributes?.quantity)
                )
                amount.payable = amount.total - amount.discount;
            }
        });
        return amount;
    }
    deviceType() {
        if (window.innerWidth > 1024) {
            return 'desktop';
        }
        else if (window.innerWidth > 992) {
            return 'tablet';
        }
        else {
            return 'mobile';
        }
    }

    campaignClickEvent(campaign: any) {
        console.log(campaign)
        if (campaign.campaignType === 'cashback') {
            // this.openContexualModal(campaign)
        }
        else {
            let queryParams: apiObjType = {}
            if (campaign.redeemable_options.includes('MembershipRedemptionOption')) {
                queryParams['memberships'] = true;
            }
            if (campaign.redeemable_options.includes('GiftCardRedemptionOption')) {
                queryParams['giftcards'] = true;
            }
            if (campaign.redeemable_options.includes('OfferRedemptionOption')) {
                queryParams['offers'] = true;
            }
            if (this.performBinValidation(campaign?.valid_bins, campaign.id, queryParams)) {
                this.router.navigate(['contextual', 'list', campaign.id], { queryParams: queryParams });
            }
        }

    }

    public performBinValidation(valid_bins: string[], campaignId: string, queryParams: any) {
        const currentCardBin = JSON.parse((this.browserStore.get('userCard')))?.attributes?.bin;
        if (!valid_bins || (valid_bins?.includes(currentCardBin))) {
            return true;
        } else {
            const userCards = JSON.parse(this.browserStore.get('userCards'));
            if (userCards) {
                const toSwitchCard = userCards?.filter((card: any) => card?.attributes?.bin === valid_bins[0])[0];
                if (toSwitchCard) {
                    this._apiService.switchCard(toSwitchCard?.id).subscribe(res => {
                        if (res && res.data && res.data.attributes.bin == toSwitchCard.attributes.bin && res.data.attributes.status == 'bin_verified') {
                          let current_user = JSON.parse(this.browserStore.get("currentUser"));
                          current_user.token = res.data.attributes.session_token;
                          if (current_user.skipExceptCard) {
                            current_user.skipExceptCard = false;
                          }
                          this.browserStore.set('currentUser', JSON.stringify(current_user));
                          this.browserStore.set('card_verified', "true");
                          this.browserStore.set('userCard', JSON.stringify(res.data));
                          this.router.navigate(['contextual', 'list', campaignId], { queryParams: queryParams }).then(() => {
                                this.browserStore.set('campaignSwitch', "true")
                                this.browserStore.set('skipReloadLogout', 'true', 'session');
                                window.location.reload();
                          });
                        }
                        else {
                          this.browserStore.set('card_verified', "false");
                        }
                    })
                }
            }
            return false;
        }
    }
  addMeta(title: string) {
    if (this.document.location.pathname.includes("shopping-dhamaka")) {
      this.pageTitle.setTitle(appConstants.titles.shopping_dhamaka_pagetitle);
      this.meta.addTags([
        { name: 'description', content: appConstants.titles.shopping_dhamaka_description },
        { name: 'keywords', content: appConstants.titles.shopping_dhamaka_keywords }
      ]);
    }
    else {
      this.pageTitle.setTitle(title);
      this.meta.addTags([
        { name: 'description', content: appConstants.titles.homepage_description },
        { name: 'keywords', content: appConstants.titles.homepage_keywords }
      ]);
    }
  }

}
export type apiObjType = {
    memberships?: any;
    giftcards?: any;
    offers?: any;
    campaignName?: any;
    specialbundle?: any;
    campaignRedemptionType?: any;
};

export type contextualApiType = {
    banners?: any,
    specialBundles?: any ,
    bannersV2?:any
}

export type campaignCardType = {
  campaignName?: string;
  benefitTitle?: string;
  benefitImg?: string,
  benefitType: keyof typeof appConstants.contexualCardBg,
  cardName?: string | undefined;
  description?: string;
  expDate?: string;
  id?: string;
  redeemable_options?: Array<{}>;
  status?:
  'all' |
  'unlocked' |
  'missed' |
  'locked' |
  'claimed' |
  'results_awaited'|
  'no-data';
  campaignType?: string;
  merchantDetails?: any;
  tcDescription?: any;
};

